import Joi from "joi";

const AppointmentSchema = Joi.object({
  unit: Joi.string().trim().required().messages({
    "any.required": "Unit is required.",
    "string.empty": "Unit is required.",
  }),
  doctorName: Joi.string().trim().required().messages({
    "any.required": "Doctor is required.",
    "string.empty": "Doctor is required.",
  }),
  visitType: Joi.string().trim().required().messages({
    "any.required": "Visit Type is required.",
    "string.empty": "Visit Type is required.",
  }),
  appointmentDateTime: Joi.date().iso().required().messages({
    "any.required": "Appointment Date and Time is required.",
    "date.format": "Appointment Date and Time must be a valid ISO date.",
    "date.base": "Appointment Date and Time must be a valid date.",
  }),
  amount: Joi.number().required().messages({
    "any.required": "Amount is required.",
    "number.base": "Amount must be a number.",
  }),
  payment: Joi.object({
    transactionId: Joi.string().allow(null).messages({
      "string.base": "Transaction ID must be a string.",
    }),
    transactionType: Joi.string().required().messages({
      "any.required": "Transaction Type is required.",
      "string.empty": "Transaction Type is required.",
    }),
    amountPaid: Joi.number().greater(0).required().messages({
      "number.greater": "Amount Paid must be greater than 0.",
      "any.required": "Amount Paid is required.",
      "number.base": "Amount Paid must be a number.",
    }),
    remarks: Joi.string().allow('').optional().messages({
      "string.base": "Remarks must be a string."
    }),
    paymentType: Joi.string().required().messages({
      "any.required": "Payment Type is required.",
      "string.empty": "Payment Type is required.",
    }),
  }).required().messages({
    "any.required": "Payment details are required.",
  }),
}).unknown(true);

export default AppointmentSchema;
